<template>
  <topbar
    :titulo="$t('ACADEMICO.IMPRIMIR_RELATORIO_TURMAS_PARA_ALUNO')"
    :subtitulo="$t('ACADEMICO.IMPRIMIR_RELATORIO_TURMAS_PARA_ALUNO_DESCRICAO')"
    :breadcrumbs="breadcrumbs"
  />
</template>
<script>
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';

export default {
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t('ACADEMICO.ACADEMICO') },
        { titulo: this.$t('ACADEMICO.RELATORIOS') },
        { titulo: this.$t('ACADEMICO.IMPRIMIR_RELATORIO_TURMAS_PARA_ALUNO') },
      ],
    };
  },
  methods: {},
};
</script>
